import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    disableButtons: { type: Boolean, default: false },
  }

  connect() {
    if (!(this.element instanceof HTMLFormElement)) {
      throw new Error('This controller must be connected to a form element')
    }

    this.element.addEventListener('submit', (ev) => {
      // if the form is submitted programmatically (e.g. the auto-submit controller) rather than
      // by the user activating a button, the submitter is null. In those cases, we still want to
      // allow multiple submits because it's typically something like a dependent dropdown getting
      // changed, and only does a GET request.
      if (ev.submitter == null) {
        return
      }

      if (this.element.classList.contains('submitting')) {
        ev.preventDefault()
      } else {
        this.element.classList.add('submitting', 'opacity-50')

        // Only disable buttons if explicitly requested via Stimulus value
        if (this.disableButtonsValue) {
          this.disableButtons()
        }
      }
    })
    // Re-enable buttons if submission fails
    this.element.addEventListener('turbo:submit-end', (event) => {
      if (!event.detail.success) {
        this.enableButtons()
        this.element.classList.remove('submitting', 'opacity-50')
      }
    })
  }

  disableButtons() {
    // Disable all buttons in the form
    const buttons = this.element.querySelectorAll('button[type="submit"], input[type="submit"]')
    buttons.forEach((button) => {
      button.disabled = true
      button.classList.add('cursor-not-allowed', 'opacity-50')
    })
  }

  enableButtons() {
    // Re-enable all buttons in the form
    const buttons = this.element.querySelectorAll('button[type="submit"], input[type="submit"]')
    buttons.forEach((button) => {
      button.disabled = false
      button.classList.remove('cursor-not-allowed', 'opacity-50')
    })
  }
}
